/**
 * Macro #26 · Increment 2 — 3D runtime error boundary (NO three import).
 *
 * Catches ANY failure while loading/rendering the lazy R3F scene (WebGL
 * unavailable, chunk load error, runtime throw) and renders a graceful
 * fallback instead of crashing the surrounding Grid / editor.
 */
import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback: ReactNode;
  onError?: () => void;
}
interface State {
  failed: boolean;
}

export class WebGLBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(): void {
    this.props.onError?.();
  }

  render(): ReactNode {
    if (this.state.failed) return this.props.fallback;
    return this.props.children;
  }
}
